export default "__VITE_ASSET__B0lnjBT6__"